// src/api/chatService.ts
import axios from 'axios';

// Detectar automáticamente el entorno
const isDevelopment = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
const API_URL = isDevelopment 
  ? 'http://localhost:8000' 
  : (process.env.REACT_APP_API_URL || 'https://chatbot-enervia-2026-a564a2e5a445.herokuapp.com');

console.log('Chat API_URL configurada:', API_URL);

export const sendMessage = async (message: string, sessionId?: string) => {
  try {
    const response = await axios.post(`${API_URL}/documents/ask`, {
      query: message,
      session_id: sessionId
    });
    return response.data;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

export const sendMessageStream = async (
  message: string, 
  sessionId: string | undefined,
  onToken: (token: string) => void,
  onSession: (sessionId: string) => void,
  onComplete: () => void,
  onError: (error: Error) => void
) => {
  try {
    const response = await fetch(`${API_URL}/documents/ask-stream`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: message,
        session_id: sessionId
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const reader = response.body?.getReader();
    const decoder = new TextDecoder();

    if (!reader) {
      throw new Error('No reader available');
    }

    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      const chunk = decoder.decode(value);
      const lines = chunk.split('\n');

      for (const line of lines) {
        if (line.startsWith('data: ')) {
          try {
            const data = JSON.parse(line.slice(6));
            
            if (data.type === 'session') {
              onSession(data.session_id);
            } else if (data.type === 'token') {
              onToken(data.content);
            } else if (data.type === 'done') {
              onComplete();
            }
          } catch (e) {
            console.error('Error parsing SSE data:', e);
          }
        }
      }
    }
  } catch (error) {
    console.error('Error in stream:', error);
    onError(error as Error);
  }
};

export const getSessionHistory = async (sessionId: string) => {
  try {
    const response = await axios.get(`${API_URL}/sessions/${sessionId}/history`);
    return response.data;
  } catch (error) {
    console.error('Error fetching history:', error);
    throw error;
  }
};

// ✅ AÑADIR: Exportar como objeto chatService
export const chatService = {
  sendMessage,
  sendMessageStream,
  getSessionHistory
};

